module.exports = __webpack_public_path__ + "img/user.68b60f24.svg";